exports = module.exports = require("../../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.scroll-text[data-v-e2f935dc] {\n  font-size: 8px;\n}\n.menu-item[data-v-e2f935dc] {\n  width: max-content;\n  /* max-width: 175px; */\n}\n.clamp-2[data-v-e2f935dc] {\n  display: -webkit-box;\n  -webkit-line-clamp: 2;\n  -webkit-box-orient: vertical;\n  overflow: hidden;\n}\n.clamp-3[data-v-e2f935dc] {\n  display: -webkit-box;\n  -webkit-line-clamp: 3;\n  -webkit-box-orient: vertical;\n  overflow: hidden;\n}\n.label-error[data-v-e2f935dc] {\n  top: 50%;\n  transform: translateY(-50%);\n}\n#tenantMenu[data-v-e2f935dc],\n#tenantMenuContent[data-v-e2f935dc] {\n  scroll-behavior: smooth;\n}\n", ""]);

// exports
